import React, { PropsWithChildren } from 'react';
import bem from '../../../../lib/bemUtils/bem';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import { Help } from '../../partials/Help/Help';
import { useHtmlValidId } from '../../../../hooks/useHtmlValidId';
import { RequiredSymbol } from '../../partials/RequiredSymbol/RequiredSymbol';

export type FieldsetModifier = Modifier<'like-label' | 'margin-bottom-20' | 'inline-radios'>;

type Fieldset = PropsWithChildren<{
  legend: string;
  modifier?: FieldsetModifier;
  helpText?: string;
  required?: boolean;
}>;

export function Fieldset({ legend, children, modifier, helpText, required }: Fieldset) {
  const helpTextId = useHtmlValidId();

  return (
    <fieldset className={bem('form2-fieldset', modifier)}>
      <legend className="form2-fieldset__legend">
        <span aria-describedby={helpText ? helpTextId : undefined} className="form2-fieldset__legend-name">
          {legend}
        </span>
        {required && <RequiredSymbol />}
        {helpText && <Help helpText={helpText} id={helpTextId} />}
      </legend>
      {children}
    </fieldset>
  );
}
